<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-title *ngIf="category">{{category?.name}}</ion-title>
    <ion-title *ngIf="!category">Todos</ion-title>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/tecservice/home" color="primary"></ion-back-button>
    </ion-buttons>
  </ion-toolbar>
  <ion-toolbar *ngIf="user && user.borrego === 1">
    <ion-segment mode="md" [(ngModel)]="show">
      <ion-segment-button value="todos" (ionSelect)="showBorregos(false)">
        <ion-label>TODOS</ion-label>
      </ion-segment-button>
      <ion-segment-button value="type_1" (ionSelect)="showBorregos(true)">
        <ion-label>MIS OPCIONES</ion-label>
      </ion-segment-button>
    </ion-segment>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <div *ngIf="businesses">
    <div [class]="'business type_'+business.type" (click)="goToBusiness(business)" *ngFor="let business of businesses">
      <ion-img class="photo" [src]="business.logo"></ion-img>
      <div class="description">
        <div class="distance">{{business.distance}}</div>
        <div class="text">
          <h4>{{business.name}}</h4>
          <p>
            <ion-icon src="assets/icon/location-pin.svg"></ion-icon>
            {{business.location_name}}
          </p>
          <p class="rating" [hidden]="!business.reviews_count">
            <ion-icon src="/assets/icon/star-fill.svg"></ion-icon>
            {{business.reviews_overall }}
            <span class="reviews">({{business.reviews_count}}+)</span>
          </p>
        </div>
        <div class="stars" [hidden]="!business.user_points||business.user_points==0||!business.reward_active">
          <p>
            {{business.user_points}}
            <ion-icon src="assets/icon/coin.svg" color="light"></ion-icon>
          </p>
        </div>
      </div>
    </div>
  </div>
</ion-content>
